
import HeaderTwo from "../components/HeaderTwo/HeaderTwoSection";
import Footer from "../components/Footer/FooterSection";
import "../styles/infopage.scss"
// import { NavLink } from "react-router-dom";


const PrivacyPolicy=()=>{

    return (
      <>
      <HeaderTwo></HeaderTwo>
    
    <div className="infopage content animate__animated animate__fadeIn animate__fast">
      <div className="section">
        <h1>Privacy Policy – Yayako Express Ltd</h1>
        <div className="content_in">
          <p>
            At Yayako Express Ltd, your privacy is important to us. This Privacy Policy explains how we collect, use, share, and protect your personal information when you visit our website, use our mobile app, or interact with our services.
          </p>
        </div>
      </div>

      <div className="section">
        <h2>1. Information We Collect</h2>

        <div className="subsection">
          <h3>Personal Information</h3>
          <p>We may collect personal details such as your name, email address, phone number, shipping address, and payment information when you create an account, place an order, or contact us.</p>
        </div>

        <div className="subsection">
          <h3>Usage Data</h3>
          <p>We automatically collect certain data about how you interact with our website and app, including your IP address, browser type, operating system, pages visited, and time spent on our platform.</p>
        </div>

        <div className="subsection">
          <h3>Cookies and Tracking Technologies</h3>
          <p>We use cookies and similar tools to enhance your experience, remember preferences, and analyze usage. You can manage cookie settings through your browser preferences.</p>
        </div>
      </div>

      <div className="section">
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li><strong>To Provide and Improve Services:</strong> We use your data to fulfill orders, manage your account, troubleshoot issues, and improve the performance of our platform.</li>
          <li><strong>To Communicate with You:</strong> We may send updates, order confirmations, promotional content, or customer support messages.</li>
          <li><strong>For Marketing Purposes:</strong> With your consent, we may send you promotional offers, newsletters, and marketing campaigns.</li>
          <li><strong>To Personalize Your Experience:</strong> Your usage data helps us tailor content, recommendations, and features to your preferences.</li>
        </ul>
      </div>

      <div className="section">
        <h2>3. How We Share Your Information</h2>
        <ul>
          <li><strong>Service Providers:</strong> We may share your data with trusted third parties who assist with operations such as payment processing, shipping, customer service, and IT support.</li>
          <li><strong>Legal Requirements:</strong> We may disclose information when legally required or to protect our rights, safety, or the safety of others.</li>
          <li><strong>Business Transfers:</strong> If Yayako Express is involved in a merger, acquisition, or asset sale, your information may be transferred to the new entity.</li>
        </ul>
      </div>

      <div className="section">
        <h2>4. Data Security</h2>
        <p>We implement reasonable security measures to protect your information from unauthorized access, alteration, or disclosure. However, please note that no method of online transmission or storage is 100% secure.</p>
      </div>

      <div className="section">
        <h2>5. Your Rights and Choices</h2>
        <ul>
          <li><strong>Access and Updates:</strong> You can view and update your personal information by logging into your account or contacting us directly.</li>
          <li><strong>Marketing Preferences:</strong> You can opt out of marketing emails by following the unsubscribe link or adjusting your account settings.</li>
          <li><strong>Cookies:</strong> You have control over cookies through your browser settings and can choose to disable or limit their use.</li>
        </ul>
      </div>

      <div className="section">
        <h2>6. Children's Privacy</h2>
        <p>Our services are not intended for children under the age of 13. We do not knowingly collect personal data from children. If we learn that such information has been collected, we will take immediate steps to delete it.</p>
      </div>

      <div className="section">
        <h2>7. Updates to This Privacy Policy</h2>
        <p>We may revise this Privacy Policy periodically. Any updates will be posted on this page along with the effective date. We encourage you to check this page regularly to stay informed about how we protect your data.</p>
      </div>

      <div className="section">
        <h2>8. Contact Us</h2>
        <p>
          If you have questions or concerns about this Privacy Policy or our data practices, please reach out to us:
          <br /><br />
          Yayako Express Ltd<br />
          📧 Email: <a href="mailto:tech@yayakoexpress.com">tech@yayakoexpress.com</a><br />
          📞 Phone: +2349138130714
          
        </p>
        <p><strong>By using our services, you consent to the terms of this Privacy Policy. Thank you for choosing Yayako Express.</strong></p>
      </div>
    </div>

    <Footer></Footer>

      </>
     )

}

export default PrivacyPolicy